import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import GroupMemberAddAutocomplete from './GroupMemberAddAutocomplete';

loadDOMComponent({
	selector: 'react-group-member-add-autocomplete',
	callback: ({ container }) => {
		const inputPlaceholder = container.getAttribute('placeholder');
		const targetHiddenId = container.getAttribute('data-target-hidden-id');

		const handleChange = value => {
			if (targetHiddenId) {
				const element = document.querySelector(
					"[data-hidden-id='" + targetHiddenId + "']",
				);

				// @ts-ignore
				element.value = value.map(v => v.id).join(',');
			}
		};

		ReactDOM.render(
			<AppContextProvider>
				<GroupMemberAddAutocomplete
					onChange={handleChange}
					placeholder={inputPlaceholder}
				/>
			</AppContextProvider>,
			container,
		);
	},
});
